var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0192308)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 52,
    height: 52,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABmJLR0QA/wD/AP+gvaeTAAAEjklEQVRYCe2ZT2hcRRzH33u7WTabVKlNRJJ1kzRCLIFoNQShoim0l8aDJ3sp2hYpBU+9eFB7yUGvgqAiiQrRg9BLoeTQFop/+y+WghEayLrJ5g9Nk1bazaZpstn1M8u+l8kLb1LMTBLjLr/vzu/3m9nf/L4zs/PmvWdZ5U95BMojUB6B7TwC9uOSa2ho2FsoFN62bfsAv3kG1ACTMkPwKfq8kM/nvx4fH/8De01Zk1BtbW11ZWVlD0TeItqa7WljQvL037OwsHBqcnJyTtWBMsG6urpYRUXFjwRoB1tBBubn5zunpqayQck4QRXCH4lEvqDcKmRIxWpntXwulCDYQRVNTU0drN0r1Mtt/sR+P5fLXZ2YmLiLbkxYHTWsjg466AYvA1cK5NUxNjY24DrkMiwbsr60tHTM5iP5bkSj0c6hoaGM5DOm8l+ZIXh/PB6/FAqFLqO/AITYjuMctSxrAKwSZ5Wn5IDL/pJaLLA/2CgyxQ5LX+xuD1E/BLKsyE2uCCREo3rgSTab/dUzNlhh6f3s6zLusz1TRajaa4UyPT09S7EpMjw8/MDX8RM+2zNVhLxG/yVl2xEK3OV0zEpjY2OUzeRJdswqttpH7JIzLJ9HOmIHxTAyQ1zD2jj7XeAcdh8ityGVZOsdX1xczEDyPHglKKH1+o0QYkZEwgdILgJkqYDkQfALpN6UK3TpRghJyd0i+bPYZ8AMcCWE/zOMMNAq2gOK7FheN5ml9nQ6/buwBRKJxE6W3k30BBASZ1k+Ozo6mhKGLhghlEqlrvkThNzfEBAXZ5eQBcGCv916bdNLzsuvtbVV/J/2eg7LujMyMpKWbC2qkRkSmXFajoXD4T3MQoT/y3OZTOZd9OdFnQC+jyjzQKsYI1QiMyCyhYgoXKRQTrMEv6fULo72iOqAOWbmJ8dxBtXN/n2tMULM0DQz8xWpfQcuAXFCCON7h4vtDTaIbnzaxQ6KSIcFuY7tNbCt3C5I50btKbbzPuoPAVf2Efc311CVj5uPowqis44btXtcm074Ynb57HWbG0ZIZMqNWk6UEqKSrkU1QojlcY6z2utkGAJFqa+v38V/59OisfyVXFb1aGE9YVZF6WI364LYHDW3gRi4RKmkKMosT49+KGoav0wRclOMoewGfhFED5t4FOb4e9JkHyHORSCe2FB4cgetl+vQS+xu/ejaxcgMkaw4BQhYzc3NT3NjV80Od58ZuQeDAjAmRgjJ2SaTSTErArLbmG5qyRlLeK3AKkJZ+cfitYpsb6Te0tKyw9ffrM/2TBWhtNcKpaqq6lWKTRFeobzm63hFbnKdIxs+/aJsc135pGX1SMlNjOillfGxHJwD7orc5DoVoW9oWACuvMhIXeZi2VXqxPUbKcXg8RzijVgsdpUO2oAreQj1uoa/VJ6gSb6PHxwBW0ZYKd9yc3gsKCHVDFnMyElG43rQjzfBf4Xj0nuqfpWExLtMXtR2WpbVA/JgsyTPzHzJ4O7nRdicKglbVSnXice7BD0ODuLfDaLApMwT/C/6Ow96eQU5iF2W8giUR6A8Av/zEfgHpdNiC2O1oJ0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.a0fe63ad806ea4c45e79b69ef428edab.svg";
export { ForwardRef as ReactComponent };